import script from "./upcoming.vue?vue&type=script&setup=true&lang=js"
export * from "./upcoming.vue?vue&type=script&setup=true&lang=js"

import "./upcoming.vue?vue&type=style&index=0&id=31f1c4f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31f1c4f8"]])

export default __exports__